import { render, staticRenderFns } from "./sectionTitle.vue?vue&type=template&id=1db1c883&"
import script from "./sectionTitle.vue?vue&type=script&lang=ts&"
export * from "./sectionTitle.vue?vue&type=script&lang=ts&"
import style0 from "./sectionTitle.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports